import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default (isOpen) =>
    createProposalModalActions[SET_IS_OPEN_MODAL](isOpen);
